import React from 'react';
import styled, { keyframes } from 'styled-components';
import em from 'polished/lib/helpers/em';
import { Link } from 'react-static';
import {ITicket} from "types/ITicket";

const slideForward = keyframes`
  0%,
  100% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(10px, 0);
  }
`;

const Footer = styled.footer`
  border-top: 0.2em solid black;
  padding-top: 3em;
  margin-top: 6.5em;
  
  @media (max-width: 1000px) {
    margin-top: ${65 / (1000 * 0.01)}vw;
  }
`;

const CTALinkLabel = styled.span`
  font-size: 1.6em;
  line-height: ${em(2.8, 1.6)};
  text-transform: uppercase;
  
  &:after {
    font-family: Flow-Poster-Bold;
    content: '→';
    display: inline-block;
    margin-left: ${em(1, 1.6)};
    line-height: ${em(2.8, 1.6)};
  }
`;

const TicketType = styled.span`
  display: block;
  font-family: Flow-Poster-Bold;
  font-size: 2.1em;
  line-height: ${em(2.4, 2.1)};
  text-transform: uppercase;
  margin-bottom: ${em(5.3, 2.1)};
`;

const Price = styled.h2`
  font-family: Flow-Inverted;
  font-size: 10em;
  white-space: nowrap;
  
  &.use-small {
    font-size: 5.5em;
  }
`;

const Currency = styled.span`
  font-family: Flow-Inverted;
  display: inline-block;
  font-size: ${em(4.8, 10)};
`;

const Wrapper = styled.div`
  a {
    display: block;
    border: 0.2em solid ${props => props.theme.highlightColor};
    padding: 2.7em 2em 3.4em;
    text-align: center;  
    
    &:${props => props.theme.hoverProperty} {
      background-color: ${props => props.theme.highlightColor};
      
      ${CTALinkLabel} {
        &:after {
          animation: ${slideForward} 0.6s ease-in-out 1;
        }
      }
    }
  }
  
  @media (max-width: 1920px) {
    ${Price} {
      font-size: ${100 / (1920 * 0.01)}vw;
      &.use-small {
        font-size: ${55 / (1920 * 0.01)}vw;
      }
    }
    
    ${TicketType} {
      margin-bottom: ${53 / (1920 * 0.01)}vw;
    }
  }
  
  @media (max-width: 1023px) {
    ${Price} {
      &.use-small {
        font-size: ${100 / (1920 * 0.01)}vw;
      }
  }
  
  @media (max-width: ${props => props.theme.textScaleStopPoint}px) {
    ${Price} {
      font-size: 3.1em;
      
      &.use-small {
        font-size: 3.1em;
      }
    }
    
    ${TicketType} {
      margin-bottom: ${em(1.65, 2.1)};
    }
    
  }
`;

interface Props {
  ticket: ITicket;
}

const TicketLift = ({
  ticket
}: Props) => {
  return (
    <Wrapper>
      <Link to={ticket.link.url}>
        <TicketType>{ticket.ticket_type}</TicketType>
        <Price className={ticket.price.length > 3 ? 'use-small' : ''}>{ticket.price}<Currency>{ticket.currency}</Currency></Price>
        <Footer>
          <CTALinkLabel>{ticket.link_label}</CTALinkLabel>
        </Footer>
      </Link>

    </Wrapper>
  )
};

export default TicketLift;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/tickets/components/ticketLift/TicketLift.tsx